var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m230 75c0-41.355-33.645-75-75-75h-80c-41.355 0-75 33.645-75 75s33.645 75 75 75h80c41.355 0 75-33.645 75-75zm-190 0c0-19.299 15.701-35 35-35h80c19.299 0 35 15.701 35 35s-15.701 35-35 35h-80c-19.299 0-35-15.701-35-35zm397 287h-80c-41.355 0-75 33.645-75 75s33.645 75 75 75h80c41.355 0 75-33.645 75-75s-33.645-75-75-75zm0 110h-80c-19.299 0-35-15.701-35-35s15.701-35 35-35h80c19.299 0 35 15.701 35 35s-15.701 35-35 35zm-190-35c0 11.046-8.954 20-20 20h-61c-38.598 0-70-31.402-70-70v-177c0-11.046 8.954-20 20-20s20 8.954 20 20v18h86c11.046 0 20 8.954 20 20s-8.954 20-20 20h-86v119c0 16.542 13.458 30 30 30h61c11.046 0 20 8.954 20 20zm110-115h80c41.355 0 75-33.645 75-75s-33.645-75-75-75h-80c-41.355 0-75 33.645-75 75s33.645 75 75 75zm0-110h80c19.299 0 35 15.701 35 35s-15.701 35-35 35h-80c-19.299 0-35-15.701-35-35s15.701-35 35-35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.ad4edaf1e3ac052790cfc4d00a9d9107.svg";
export { ForwardRef as ReactComponent };